/* src/app/cardholders/cardholder-details/cardholder-details.component.css */
/*# sourceMappingURL=cardholder-details.component.css.map */
